module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACpSURBVHgBrZPdDYMgFIUPxEHqU9NtDBN0g7pBdYKmG7QLmG7T2D7oJKBcEqOIiOKXXP459wCBQdQKe6jOTFcckSS24iqW48Q3OcOR5MAjLGTYJmAfwSWox7I6cwv4EP87IHPTYa+++FBryOqzL34PQOXTQVmiuhSBl6iuZo9MKQh+oxKRBArIp1nNGwoypd66YgF/oe3vJ116oRAHp5GT0sQexLdwtmPpAJjsNiIeAa1/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imag2.png
// module id = bXLx
// module chunks = 0